import type { EditorBlock } from "../editor.types";
import "./blockFlow.css";

/** The class for a page's column of blocks, on the canvas and the live site. */
export const BLOCK_FLOW_CLASS = "block-flow";

/**
 * Labels a non-text block's outer element with its type and style, which
 * blockFlow.css uses to space it.
 */
export const flowAttributes = (block: EditorBlock): Record<string, string> => {
  const content = (block.content ?? {}) as { display?: string; layout?: string; style?: string };
  const style =
    block.block_type === "page"
      ? (content.display ?? "card")
      : block.block_type === "library"
        ? (content.layout ?? "grid")
        : block.block_type === "columns"
          ? (content.style ?? "even")
          : block.block_type === "section"
            ? (content.style ?? "plain")
          : block.block_type === "video"
            ? (content.style ?? "standard")
            : "";
  return { "data-block": block.block_type, ...(style ? { "data-style": style } : {}) };
};
